(function() {
    'use strict';
    
    function initializeStaticPageContent() {
        const staticPage = document.getElementById('staticpage-content');
        
        // Exit if the static page container doesn't exist
        if (!staticPage) {
            return;
        }
        
        // Add responsive class to all images
        const images = staticPage.querySelectorAll('img');
        images.forEach((img) => {
            img.classList.add('img-fluid');
        });
        
        // Wrap tables in responsive div and add table class
        const tables = staticPage.querySelectorAll('table');
        tables.forEach((table) => {
            const parentEl = table.parentNode;
            
            // Skip if parent doesn't exist or table is already wrapped
            if (!parentEl || parentEl.classList.contains('table-responsive')) {
                return;
            }
            
            const wrapper = document.createElement('div');
            table.classList.add('table');
            wrapper.classList.add('table-responsive');
            parentEl.insertBefore(wrapper, table);
            wrapper.appendChild(table);
        });
    }
    
    // Handle both sync and async loading
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeStaticPageContent);
    } else {
        initializeStaticPageContent();
    }
})();